import React from 'react';
import { Toast } from 'shared-components/BaseToast/Toast';
import CampaignSection from './CampaignSection/CampaignSection';

import styles from './CampaignAdmin.module.scss';

const CampaignAdmin = () => {
  return (
    <>
      <div className={styles.container}>
        <div className={styles.campaignContainer}>
          <h3>Import Campaign</h3>
          <div className={styles.seasonsContainer}>
            <CampaignSection seasonTitle="Current Season" isCurrentCampaign />
            <CampaignSection seasonTitle="Next Season" />
          </div>
        </div>
      </div>
      <Toast />
    </>
  );
};

export default CampaignAdmin;
